export const GET_PLAN_ASSETALLOCATION_ABORTED =
  'GET_PLAN_ASSETALLOCATION_ABORTED';
export const GET_PLAN_ASSETALLOCATION_REQUESTED =
  'GET_PLAN_ASSETALLOCATION_REQUESTED';
export const GET_PLAN_ASSETALLOCATION_COMPLETED =
  'GET_PLAN_ASSETALLOCATION_COMPLETED';
export const GET_PLAN_ASSETALLOCATION_FAILED =
  'GET_PLAN_ASSETALLOCATION_FAILED';
export const RESET_PLAN_ASSETALLOCATION_REQUESTED =
  'RESET_PLAN_ASSETALLOCATION_REQUESTED';
export const RESET_PLAN_ASSETALLOCATION_COMPLETED =
  'RESET_PLAN_ASSETALLOCATION_COMPLETED';
